export const config = {
	main: {
		VERSION: '0.0.2',
		SERVICE_ADMIN: process.env.VUE_APP_MODE == 'prod' ? process.env.VUE_APP_SERVICE_ADMIN : process.env.VUE_APP_SERVICE_ADMIN_DEV,
		SERVICE_GRAPHQL: process.env.VUE_APP_MODE == 'prod' ? process.env.VUE_APP_SERVICE_GRAPHQL : process.env.VUE_APP_SERVICE_GRAPHQL_DEV,
		marketplace: 'BPL',
		ACCEPT_LANGUAGE: 'ru'
	}
}
